import { render, staticRenderFns } from "./realtime-card.vue?vue&type=template&id=768689ca&"
import script from "./realtime-card.vue?vue&type=script&lang=ts&"
export * from "./realtime-card.vue?vue&type=script&lang=ts&"
import style0 from "./realtime-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports